import config from './config';

export const buildApiUrl = (path: string): string => {
  const baseURL = config?.LSNextApi?.baseURL ?? '';
  const cleanBase = baseURL.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${cleanBase}${cleanPath}`;
};
